import React from 'react'
import Header from './Header.js'
import HeadNav from './HeadNav.js'

export default function HeadSection() {
  return (
    <section id='head'>
      <Header/>
      <HeadNav/>
    </section>
  )
}